<template>
	<div>
		<div class="fs5 lh125 fw7 c1 mb2">Premium</div>
		<case-form
			:isBoxed="false"
			size="small"
			gap="1"
			:schema="[
				{
					component: 'select',
					defaultValue: 'USD',
					props: {
						options: currencies,
						placeholder: 'Select displayed premium currency'
					},
					bindTo: 'case.facts.premiumCurrency'
				}
			]"
		/>

		<offer-premium-info
			:caseId="$store.state.caseManagement.caseId"
			:proposalId="$store.state.caseManagement.proposalId"
			:offerId="$store.state.caseManagement.offerId"
			:productId="productId"
			:pricing="pricing"
			:hasLoadingsActions="true"
			:hasDiscountActions="true"
			:hasDiscountLogic="true"
			:discountNameOptions="discountNameOptions"
			@premium:updated="fetchPricing"
			@premium:added="fetchPricing"
			@discount:updated="fetchPricing"
			@discount:added="fetchPricing"
			@discount:deleted="fetchPricing"
			@loadings:updated="fetchPricing"
			@loadings:added="fetchPricing"
			@loadings:deleted="fetchPricing"
		/>

		<!-- TODO: Recalculate button? -->

		<!-- Commissions Summary -->
		<berkley-premium-commission class="mt2" />
	</div>
</template>

<script>
import CaseForm from "../CaseForm/CaseForm"
import OfferPremiumInfo from "../PremiumInfo/OfferPremiumInfo"
import BerkleyPremiumCommission from "./BerkleyPremiumCommission"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		CaseForm,
		OfferPremiumInfo,
		BerkleyPremiumCommission
	},

	data() {
		return {
			discountNameOptions: [],

			currencies: [
				{
					name: "AED",
					value: "AED"
				},
				{
					name: "AUD",
					value: "AUD"
				},
				{
					name: "BND",
					value: "BND"
				},
				{
					name: "EUR",
					value: "EUR"
				},
				{
					name: "IDR",
					value: "IDR"
				},
				{
					name: "INR",
					value: "INR"
				},
				{
					name: "KRW",
					value: "KRW"
				},
				{
					name: "LKR",
					value: "LKR"
				},
				{
					name: "MUR",
					value: "MUR"
				},
				{
					name: "MYR",
					value: "MYR"
				},
				{
					name: "PHP",
					value: "PHP"
				},
				{
					name: "PKR",
					value: "PKR"
				},
				{
					name: "QAR",
					value: "QAR"
				},
				{
					name: "SAR",
					value: "SAR"
				},
				{
					name: "SGD",
					value: "SGD"
				},
				{
					name: "THB",
					value: "THB"
				},
				{
					name: "USD",
					value: "USD"
				},
				{
					name: "TWD",
					value: "TWD"
				},
				{
					name: "CNY",
					value: "CNY"
				},
				{
					name: "JPY",
					value: "JPY"
				},
				{
					name: "OMR",
					value: "OMR"
				},
				{
					name: "HKD",
					value: "HKD"
				},
				{
					name: "GBP",
					value: "GBP"
				}
			]
		}
	},

	computed: {
		selectedOffer() {
			const cache = this.$store.state.caseManagement.proposals
			const proposalId = this.$store.state.caseManagement.proposalId
			const offerId = this.$store.state.caseManagement.offerId

			return (
				cache
					?.find(proposal => proposal.id === proposalId)
					?.basket?.find(offer => offer.id === offerId) || {}
			)
		},

		// Get pricing of selected offer on selected proposal
		pricing() {
			return (
				this.selectedOffer?.premium?.convertedPrices?.[0] ||
				this.selectedOffer?.premium ||
				{}
			)
		},

		productId() {
			return this.selectedOffer?.product?.productId || {}
		}
	},

	methods: {
		async fetchPricing() {
			// Find case currencyCode in case facts
			const caseCurrencyCode = this.$store.state.caseManagement.case?.facts?.find(
				fact => fact.type === "premiumCurrency"
			)?.value?.stringValue

			await this.$store.dispatch("caseManagement/fetchProposals", {
				caseId: this.$store.state.caseManagement.caseId,
				options: { currencyCodes: [caseCurrencyCode] }
			})
		},

		async fetchDiscountNames() {
			// TODO: This is based on name of the code which is bit fragile
			// because if they change `name` it will not fetch proper templates
			// In future it should be based on `code` field that will be unique
			const query = gql`
				query getDiscountNames {
					templates(where: { type: "dynamic", name: "discounts" }) {
						totalCount
						list {
							id
							name
							description
							... on dynamicTemplate {
								dynamicValues {
									valueId
									valueJsonString
								}
							}
						}
					}
				}
			`
			const res = await api({ query, variables: {} })

			try {
				this.discountNameOptions = res?.data?.templates?.list?.[0]?.dynamicValues
					?.map(item => ({
						...JSON.parse(item.valueJsonString)
					}))
					.map(item => ({
						name: item.name,
						value: item.name
					}))
			} catch (err) {
				console.error(err)
			}
		}
	},

	mounted() {
		this.fetchDiscountNames()
	}
}
</script>
